/**
 * The app-wide store singleton.
 *
 * Importing this module constructs a repository (and, for `LocalRepository`, a
 * real `BroadcastChannel`). Tests want neither, so they import
 * `store/createStore.ts` directly.
 */

import { createRepository } from '../repo/index.ts';
import { createQdStore } from './createStore.ts';
import type { QdStoreApi } from './createStore.ts';

export const useQd: QdStoreApi = createQdStore({ repo: createRepository() });

export { createQdStore } from './createStore.ts';
export type { CreateStoreDeps, QdStoreApi } from './createStore.ts';
export type { QdStore } from './types.ts';
export * as selectors from './selectors.ts';
